module.exports = __webpack_public_path__ + "static/media/ks_shack_locked_kayak.8fee8f2c.svg";